import { Component, EventEmitter, HostListener, Output, Input, ChangeDetectorRef, ElementRef, ViewChild, effect, inject, untracked } from '@angular/core';
import { InteractionService } from '../../service/interaction/interaction.service';
import { RoleplayApiService } from '../../service/roleplay.service';
import { RolePlayEndRequest } from '../../model/rolePlay';
import { finalize, map, Observable, startWith, Subscription } from 'rxjs';
import { Router } from '@angular/router';
import { ChatService } from '../../service/chat-service';
import { HttpClient } from '@angular/common/http';
import { MatDialog } from '@angular/material/dialog';
import { ConfirmationDialogComponent } from '../confirmation-dialog/confirmation-dialog.component';
import { DownloadIosDialogComponent } from '../download-ios-dialog/download-ios-dialog.component';
import { CONVERSATION_SERVICE } from '../../service/service-url';
import { ToastrService } from 'ngx-toastr';
import { ChatDetails, RefreshHistory } from '../../model/interaction.model';
import { ConstantConfig, DASHBOARD_INFO, SPECIALITY_INFO_MSG } from '../../utility/constant-config';
import { TextToSpeechService } from '../../service/text-to-speech/text-to-speech.service';
import { EncryptionService } from '../../service/encryption/encryption.service';
import { FormBuilder, Validators } from '@angular/forms';
import { TraineeListService } from '../../service/trainee-list.service';
import { MAT_SELECT_CONFIG } from '@angular/material/select';
import { MatMenuTrigger } from '@angular/material/menu';
import { PlatformRegionService } from '../../../app/service/shared/platform-region.service'
import { ChatRegionMarketService } from '../../v2/modules/roleplay/services/chat-region-market.service';
import { SpinnerService } from '../../service/shared/spinner-service.service';
import { RoleStateService } from '../../v2/services/core/role-state.service';
import { AppLaunchPromptService } from '../../service/app-launch-prompt.service';
import { QuizNavigationService } from '../../v2/modules/quiz/services/quiz-navigation.service';
import { QUIZ_MENU_CODE } from '../../v2/modules/quiz/constants/quiz.constants';
import { QuizHistoryResponse } from '../../v2/models/quiz/quiz-api.models';

@Component({
    selector: 'app-sidebar-chatbot',
    templateUrl: './sidebar-chatbot.component.html',
    styleUrl: './sidebar-chatbot.component.scss',
    providers: [
        {
            provide: MAT_SELECT_CONFIG,
            useValue: { overlayPanelClass: 'custom-multi-select-panel' },
        },
    ],
    standalone: false
})
export class SidebarChatbotComponent {
  subscription: Subscription;
  @Output() response = new EventEmitter<number>();

  historySubscription: any = new Subscription();
  prefixUrl: string = "../../../assets/images/history-small-icon.svg";
  suffixUrl: string = "../../../assets/images/history-person-icon.svg";
  givenName: string;
  config: any = ConstantConfig;
  showSidebar: boolean = true;
  showChatFocus: boolean = false;
  adminChatFocus: boolean = false;
  showHistoryList: boolean = false;
  isVisible: boolean = false;
  isRenaming = false;
  allowedRegions: any[] = [];
  chatSession_Id: number;
  dataFromParent: RolePlayEndRequest;
  todayHistory: any = [];
  yesterdayHistory: any = [];
  monthHistory: any = [];
  weekHistory: any = [];
  historyList: any = [];
  menuArr: any = [];
  dynamicMenuOpenClose = {};
  showOptions = false;
  isEditing = false;
  editedChatName = '';
  userId: number = 0;
  userRole: string;
  item: any;
  selectedChatHistory: any;
  items: any[] = []; // Your items array
  chatType: string = 'Chat'; //AbioChat,FAQ,Roleplay,EmailCoach
  subType: string = "";
  selectedMenu: string | null = null;
  selectedParentMenu: string | null = null;
  selectedHistoryId: number | null = null;
  chatHistoryType: string = 'chat'; // AbioChat, faq, role-play, role-play-practice
  dashRolPlay: string = '';
  timeLeft: number = 0;
  private debounceTimeout: any = null;
  private confirmationCounter: number = 0;
  defaultMenuArr: any = [];
  productList = [];
  menuForm: any;
  private chatStatusSubscription: Subscription;
  @ViewChild('searchRegion') regionSearchTextBox: ElementRef;
  regionSelectedValues = '';
  regionData = [];
  regionFilteredOptions: Observable<any[]>;
  @ViewChild('searchMarket') marketSearchTextBox: ElementRef;
  marketSelectedValues = [];
  marketData = [];
  marketFilteredOptions: Observable<any[]>;
  primaryMarketEnabled = true;
  previousRegionValue = ""
  previousMarketValue = []
  showRegion: boolean = true;
  isHistoryClicked = false;
  @ViewChild('searchProduct') productSearchTextBox: ElementRef;
  productSelectedValues = [];
  productData = [];
  productFilteredOptions: Observable<any[]>;
  previousProductValue = "";
  menuHeader: string;
  @ViewChild(MatMenuTrigger) menu: MatMenuTrigger;
  @ViewChild('mobileIosDownload') mobileIosDownloadRef: ElementRef;
  private _regionSelectSubscription: Subscription | null = null;
  device_type: string;
  readonly quizNavigation = inject(QuizNavigationService);
  readonly quizMenuCode = QUIZ_MENU_CODE;
  // Keeps the quiz History groups current (first load and refreshes after a quiz starts or ends).
  private readonly quizHistorySync = effect(() => {
    const history = this.quizNavigation.recentHistory();
    untracked(() => {
      if (this.chatHistoryType === QUIZ_MENU_CODE) {
        this.applyQuizHistory(history);
      }
    });
  });

  constructor(public intService: InteractionService, private rolePlayService: RoleplayApiService,
    public Router: Router, public ChatService: ChatService, private http: HttpClient, private dialog: MatDialog,
    private toastr: ToastrService, private tts: TextToSpeechService, private encryptionService: EncryptionService, public fb: FormBuilder, public TraineeService: TraineeListService, private cdr: ChangeDetectorRef,
    private PlatformRegionService: PlatformRegionService, private chatRegionMarketService: ChatRegionMarketService,
    private spinnerService: SpinnerService, private roleStateService: RoleStateService,
    private appLaunchPromptService: AppLaunchPromptService) { }

  ngOnInit() {
    this.isMobileOrTabletDevice = this.computeIsMobileOrTabletView();
    this.primaryMarketEnabled = (sessionStorage.getItem("primaryMarketEnabled") === 'true');
    this.userRole = sessionStorage.getItem('role');
    this.givenName = sessionStorage.getItem("givenName");
    this.userId = Number(sessionStorage.getItem('userId'));
    this.chatStatusSubscription = this.intService.chatstatus.subscribe((status: ChatDetails) => {
      if (status.chat_identifier === 'newchat') {
        this.selectedMenu = 'newchat';
      }
    });
    this.getMenuDetails();
    this.getProductMetaData();
    // Reflect the shared collapse (icon-rail) state. showSidebar === true means expanded.
    this.subscription = this.intService.sidebarCollapsed$.subscribe((collapsed: boolean) => {
      this.showSidebar = !collapsed;
    });
    this.intService.activeMenu.subscribe((menuName: string) => {
      this.selectedMenu = menuName;
      this.selectedParentMenu = null;
      this.cdr.detectChanges();
    });
    this.rolePlayService.visibility$.subscribe(
      (isVisible) => this.isVisible = isVisible
    );
    this.rolePlayService.setFeedbackValue$.subscribe((data: RolePlayEndRequest) => {
      this.dataFromParent = data;
    });
    this.intService.reloadHistoryObservable$.subscribe((data: RefreshHistory) => {
      this.chatHistoryType = data.refreshMenu;
      this.getHistoryList(data.refreshMenu, data.subType, data.id, data.dashRolePlay);
    });
    this.setInitialMenuHighlight();
    this.checkMobileDevice();
    this.intService.productObservable$.subscribe(res => {
      this.productList = res;
      this.getMenuDetails()
    })
    this.intService.refreshMenuList.subscribe(() => {
      this.getMenuDetails();
      this.setInitialMenuHighlight();
    });
    this.intService.isProductSelected.subscribe(res => {
      if (res) {
        this.getMenuDetails();
        this.getHistoryList(this.chatType, this.chatType);

        this.ChatService.getPrimaryRegion(sessionStorage.getItem('businessUnitCode')).subscribe(val => {
          const allRegions = Array.isArray(val) ? val : [];
          const filteredRegionData = (this.allowedRegions && this.allowedRegions.length > 0)
            ? allRegions.filter(r => r.region_name && this.allowedRegions.includes(r.region_name.toString()))
            : allRegions;

          // update component and sessionStorage
          this.regionData = filteredRegionData;
          sessionStorage.setItem('regionData', JSON.stringify(this.regionData));
        });
        let selectedProduct: any = this.productList.filter(item => item.business_unit_code.toString() === sessionStorage.getItem('businessUnitCode').toString());
        sessionStorage.setItem('primaryMarketEnabled', selectedProduct[0]?.is_primary_market_enabled);
        this.primaryMarketEnabled = (sessionStorage.getItem("primaryMarketEnabled") === 'true');
        if (res === 'region') {
          this.menuForm.controls['marketSelectFormControl'].setValue([]);
          this.marketSelectedValues = [];
        } else if (res === 'market') {
          return;
        } else if (res === 'platform') {
          this.loadRegions('region');
        } else if (res === 'profile') {
          this.menuForm.controls['categoryName'].setValue(sessionStorage.getItem("businessUnitCode"));
          this.menuForm.controls['marketSelectFormControl'].setValue([]);
          this.marketSelectedValues = [];
          this.loadRegions('profile');
          this.getProductMetaData();
        } else {
          if (sessionStorage.getItem("defaultRegion") && sessionStorage.getItem("defaultRegion").toString() !== "null") {
            this.loadRegions(sessionStorage.getItem("defaultRegion"));
          }
        }
      }
    });
    this.menuForm = this.fb.group({
      categoryName: ['', [Validators.required]],
      regionSelectFormControl: ['null'],
      regionSearchTextboxControl: [''],
      marketSelectFormControl: [[]],
      marketSearchTextboxControl: [''],
      productSelectFormControl: [[]],
      productSearchTextboxControl: [''],
    });
    this.menuForm.controls['categoryName'].setValue(sessionStorage.getItem('businessUnitCode'))

    this.regionFilteredOptions = this.menuForm.controls['regionSearchTextboxControl'].valueChanges
      .pipe(
        startWith<string>(''),
        map((name: any) => this._filterRegion(name))
      );

    this.marketFilteredOptions = this.menuForm.controls['marketSearchTextboxControl'].valueChanges
      .pipe(
        startWith<string>(''),
        map((name: any) => this._filterMarket(name))
      );

    this.productFilteredOptions = this.menuForm.controls['productSearchTextboxControl']?.valueChanges
      .pipe(
        startWith<string>(''),
        map((name: any) => this._filterProduct(name))
      );
  }
  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    this.checkMobileDevice();
    this.isMobileOrTabletDevice = this.computeIsMobileOrTabletView();
  }
  checkMobileDevice() {
    // Auto-collapse on small screens, but never force-expand on desktop so a
    // user's manual collapse choice survives window resizes.
    if (window.innerWidth <= 1024) {
      this.intService.setSidebarCollapsed(true);
    }
  }

  getMenuDetails() {
    const decryptText = this.encryptionService.decrypt(sessionStorage.getItem('groups'));
    const groups = JSON.parse(decryptText);
    if (this.ChatService.isRunningInBrowserTab()) {
      this.device_type = 'web'
    }
    const requestBusinessUnitCode = sessionStorage.getItem('businessUnitCode') || '';
    this.spinnerService.show();
    const selectedRoleCode = this.roleStateService.getSnapshot().selectedRoleCode || sessionStorage.getItem('roleCode');

    let payload = {
      ad_group: groups.join(','),
      primary_ad_group: selectedRoleCode,
      business_unit_code: requestBusinessUnitCode,
      device_type: this.device_type,
      wwid: sessionStorage.getItem('userId')
    };
    this.ChatService.getMenuDetails(payload).pipe(
      finalize(() => this.spinnerService.hide())
    ).subscribe({
      next: (response) => {
        if (response.length > 0) {
          // Only show the iOS download card when the menu API returns this entry; use its label as the title.
          const iosDownloadMenu = response.find(item => item.menu_code === 'downloadIosApp');
          this.showMobileIosDownload = !!iosDownloadMenu;
          this.mobileIosTitle = iosDownloadMenu?.menu_label || this.mobileIosTitle;

          this.menuArr = response.filter(item => item.menu_metadata?.menu_type !== 'default' && item.menu_code !== 'downloadIosApp');
          this.defaultMenuArr = response.filter(item => item.menu_metadata?.menu_type === 'default');

          this.defaultMenuArr.forEach(parent => {
            parent.children.sort((a, b) => a.menu_code.localeCompare(b.menu_code));
          });
          this.menuArr.sort((a, b) => a.parent_menu_order - b.parent_menu_order);
          this.menuArr.forEach((item, index) => {
            this.dynamicMenuOpenClose[index] = false;
          });
        } else {
          this.menuArr = [];
          this.defaultMenuArr = [];
          this.showMobileIosDownload = false;
        }
      },
      error: (error) => {
        console.error('Failed to load sidebar menu', error);
        this.spinnerService.hide()
        this.toastr.error('Unable to refresh menu. Please try again.', '', { positionClass: 'toast-top-right' });
      }
    });
  }

  private setInitialMenuHighlight() {
    this.selectedMenu = 'newchat'; // Set appropriate value for TRAINER if needed
    if (sessionStorage.getItem('newtab') === 'yes') {
      this.Router.navigate(['/app-doc-viewer'], { skipLocationChange: true });
    } else {
      this.selectedMenu = 'newchat';
      this.Router.navigate(['/app-abiomed-chat'], { skipLocationChange: true });
    }
    this.selectedMenu = 'newchat'; // Highlight 'newchat' menu item for TRAINEE
    if (sessionStorage.getItem('newtab') === 'yes') {
      this.Router.navigate(['/app-doc-viewer'], { skipLocationChange: true });
      this.Router.navigate(['/app-abiomed-chat'], { skipLocationChange: true });
    }
  }

  veevaVault() {
    this.Router.navigate(['/app-document-list'], { skipLocationChange: true });
    this.showChatFocus = false;
  }

  sendResponse() {
    if (this.isVisible) {
      const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
        width: '350px',
        data: { message: 'Are you sure you want to end the roleplay?' }
      });

      dialogRef.afterClosed().subscribe(result => {
        if (!result) {
          return;
        } else {
          this.rolePlayService.hideDiv(false);
          let questionRequest: RolePlayEndRequest = this.dataFromParent;
          if (questionRequest.session_type === 'role-play') {
            this.rolePlayService.endRolePlayRequest(questionRequest).subscribe((data: any) => {
              this.rolePlayService.submitFeedbackHandler({ type: 'S', value: data.roleplay_session_score, feedback: data.roleplay_session_feedback });
            });
          } else {
            this.rolePlayService.submitFeedbackHandler({ type: 'S', value: 0, feedback: 'No conversations were found regarding Roleplay.' });
          }
          this.intService.endRoleplayUpdate('endroleplay');
          this.rolePlayService.setRoleplayInfoSidebar({});
          this.isVisible = false;
        }
      });
    }
  }

  vvdashboard() {
    this.Router.navigate(['/app-veeva-vault-dashboard'], { skipLocationChange: true });
  }

  ampDataSource() {
    this.Router.navigate(['/app-amp-data-source-list'], { skipLocationChange: true });
  }

  Customize() {
    this.Router.navigate(['/app-customize-dialog'], { skipLocationChange: true });
  }

  queryCoach() {
    this.Router.navigate(['/app-cust-faq'], { skipLocationChange: true });
  }

downloadiOS(){
  this.dialog.open(DownloadIosDialogComponent, { width: '600px', maxWidth: '95vw' });
}

readonly mobileAppStoreUrl = 'https://apps.apple.com/us/app/j-j-medtech-ai-advisor/id6756101233';
isMobileIosExpanded = false;
// Only rendered when the menu API response includes a "downloadIosApp" entry.
showMobileIosDownload = false;
mobileIosTitle = 'Download AI Advisor iOS App';
isMobileOrTabletDevice: boolean;

computeIsMobileOrTabletView(): boolean {
  return this.appLaunchPromptService.getPlatform() !== 'other';
}

toggleMobileIosDownload(event?: Event): void {
  if (!this.showSidebar) {
    event?.stopPropagation();
    this.intService.setSidebarCollapsed(false);
    this.isMobileIosExpanded = true;
    this.scrollIosDownloadIntoView();
    return;
  }
  this.isMobileIosExpanded = !this.isMobileIosExpanded;
  if (this.isMobileIosExpanded) {
    this.scrollIosDownloadIntoView();
  }
}

// The sidebar scrolls internally, so the newly expanded content can end up below the fold; bring it into view.
private scrollIosDownloadIntoView(): void {
  setTimeout(() => {
    this.mobileIosDownloadRef?.nativeElement.scrollIntoView({ behavior: 'smooth', block: 'end' });
  });
}

openAppStore(): void {
  window.open(this.mobileAppStoreUrl, '_blank', 'noopener,noreferrer');
}

  // -----------------------------------------------------------------
  // METHOD PURPOSE:
  //   Loads the chat history groups (today, week, month) for the sidebar.
  //
  // MODIFICATION HISTORY (latest first – keep ONLY the last 3):
  //   [JHUD-5314] 2026-10-30 16:41 | Vikas Kumar | Removed mock data; today's history comes from the API again.
  // -----------------------------------------------------------------
  getHistoryList(param, subType?, id?, dashRolePlay?, action?) {
    if ((subType === 'History' || param === 'History') && (action !== 'delete')) {
      return;
    }
    if (subType === 'History') {
      subType = '';
    }
    const userId: number = this.userId;
    const length: number = 20;
    const raw = sessionStorage.getItem('regionData');
    //let  selectedRegion = this.PlatformRegionService.selectedRegion.name;
    this.chatRegionMarketService.initialize();
    const selectedRegion = this.chatRegionMarketService.selected_region_code || this.PlatformRegionService.selectedRegion.name || '';
    sessionStorage.setItem('region', selectedRegion);
    this.historySubscription = this.ChatService.chatHistoryList(userId, length, param, id, subType, selectedRegion).subscribe({
      next: (res: any) => {
        if (res) {
          if (dashRolePlay) {
            this.dashRolPlay = "dashRolePlay";
          }
          // Check if the response contains data for today
          this.todayHistory = res.today ? res.today : [];
          // Check if the response contains data for yesterday
          this.yesterdayHistory = res.current_week ? res.current_week : [];

          // Check if the response contains data for one month ago
          this.monthHistory = res.one_month_ago ? res.one_month_ago : [];

          // Check if the response contains data for last week
          this.weekHistory = res.last_week ? res.last_week : [];

          // Update historyList if needed
          this.historyList = {
            today: this.todayHistory,
            yesterday: this.yesterdayHistory,
            one_month_ago: this.monthHistory,
            last_week: this.weekHistory
          };
        } else {
          console.error('Empty response received from the server');
          // Handle empty response gracefully (e.g., show a message to the user)
        }
      },
      error: (error) => {
        console.error('Error occurred while fetching chat history:', error);
        // Handle errors (e.g., show an error message to the user)
      }
    });

      this.ChatService.verifyShowPadUser({
      user_email: sessionStorage.getItem('userEmail'),
      business_unit_code: sessionStorage.getItem('businessUnitCode'),
      region: sessionStorage.getItem('region') || '',

    }).subscribe({
      next: (res: any) => {
        if (res && res.is_active) {
          sessionStorage.setItem('is_showpad_user', 'true');
        }else {
          sessionStorage.setItem('is_showpad_user', 'false');
        }
      }
    });

  }

  chatFocusHandler() {
    this.showChatFocus = !this.showChatFocus;
  }

  adminFocusHandler() {
    this.adminChatFocus = !this.adminChatFocus;
  }

  historyHandler() {
    this.showHistoryList = !this.showHistoryList;
  }

  feedbackHandler(Menu: string) {
    this.Router.navigate(['/app-feedback', { queryParams: { menu: Menu } }], { skipLocationChange: true });
  }

  feedbackTraineeHandler() {
    this.Router.navigate(['/app-feedback-trainee', { mode: 'roleplay' }], { skipLocationChange: true });
  }

  roleplayHandler() {
    this.tts.resetAudio();
    if (this.isVisible) {
      const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
        width: '350px',
        data: { message: 'Are you sure you want to get out of Roleplay?' }
      });
      dialogRef.afterClosed().subscribe(result => {
        if (!result) {
          return;
        } else {
          this.chatType = 'role-play';
          this.subType = "";
          this.Router.navigate(['/roleplay/training-dashboard'], { skipLocationChange: true });
        }
      })
    } else {
      this.chatType = 'role-play';
      this.subType = "";
      // this.Router.navigate([`a`], { skipLocationChange: true, queryParams: { id: 19959 } });
      this.Router.navigate(['/roleplay/training-dashboard'], { skipLocationChange: true });
    }
    this.selectedMenu = 'roleplay';
    this.showChatFocus = false;
  }

  quizHandler() {
     this.chatType = 'quiz';
    // this.intService.setChatStatus({ chat_identifier: QUIZ_MENU_CODE });
    this.quizNavigation.openNewQuiz();
    this.chatHistoryType = QUIZ_MENU_CODE;
    this.showChatFocus = false;
    this.showRegion = false;
    this.isHistoryClicked = false;
  }

  systemPrompt() {
    this.adminChatFocus = true;
    this.Router.navigate(['/app-system-prompt-tab'], { skipLocationChange: true });
  }

  goToSkills() {
    this.adminChatFocus = true;
    this.Router.navigate(['/admin/skills/list'], { skipLocationChange: true });
  }

  goToGlobalConfiguration() {
    this.adminChatFocus = true;
    this.Router.navigate(['/admin/global_cofiguration'], { skipLocationChange: true });
  }
  requestCategory() {
    this.adminChatFocus = true;
    this.Router.navigate(['/admin/request-category'], { skipLocationChange: true });
  }

  navigateToComponent(chatType: string) {
    this.showChatFocus = true;
    this.Router.navigate(['/app-cust-faq'], { skipLocationChange: true });
    this.selectedMenu = 'dqc';
  }

  navigateToRequestList() {
    this.adminChatFocus = true;
    this.Router.navigate(['/app-request-list'], { skipLocationChange: true });
    this.selectedMenu = 'contactcenter';
  }

  navigateToRoleplayFeedbackList() {
    this.Router.navigate(['/app-cc-roleplay-feedback'], { skipLocationChange: true });
    this.showChatFocus = false;
    this.showRegion = false;
  }

  isContactCenterMenu(item: any): boolean {
    return item.children?.some((c: any) => c.menu_code === 'bugReport' || c.menu_code === 'issueRequest');
  }

  trainerdashboard() {
    this.TraineeService.getCustomizeDetails().subscribe(res => {
      if (res?.dashboard_url) {
        let URL = res.dashboard_url + '?filter=aiadvisor_business_unit_metadata/business_unit_name eq \'';
        const businessUnit = sessionStorage.getItem("businessUnit");
        const encodedBusinessUnit = businessUnit.includes('&') ? encodeURIComponent(businessUnit) : businessUnit;

        URL += `${encodedBusinessUnit}\'`;

        const selectedLabels = this.productSelectedValues?.map(val => {
          const foundItem = this.productData?.find(item => item.code === val);
          return foundItem ? `'${foundItem.code}'` : null;
        }).filter(code => code !== null)
          .join(',');
        if (this.productSelectedValues?.length && this.productSelectedValues.length !== this.productData?.length && selectedLabels) {
          const labelsArray = selectedLabels.split("','").map(code => {
            code = code.replace(/^'/, '').replace(/'$/, '').trim();
            const encodedLabel = encodeURIComponent(code);
            return `'${encodedLabel}'`;
          });
          const safeLabels = labelsArray.join(',');

          URL += ` and aiadvisor_chat_session/product in (${safeLabels})`;
        }
        window.open(URL, "_blank");
      } else {
        this.toastr.info(DASHBOARD_INFO);
      }
      this.selectedMenu = 'trainerdashboard';
      this.showChatFocus = false;
    });
  }

  adminDashboard() {
    this.TraineeService.getCustomizeDetails().subscribe(res => {
      if (res?.admin_dashboard_url) {
        window.open(res.admin_dashboard_url, "_blank");
      } else {
        this.toastr.info(DASHBOARD_INFO);
      }
      this.selectedMenu = 'AdminDashboard';
      this.showChatFocus = false;
    });
  }

  onParentMenuToggle(item: any, index: number, event?: Event): void {
    const isExpandable = (item?.children?.length > 0) || item?.menu_code === 'History';
    // When the rail is collapsed, clicking the icon of a parent that has child items
    // should only expand the sidebar (and open that parent) without starting a new chat.
    if (!this.showSidebar && isExpandable) {
      event?.stopPropagation();
      this.intService.setSidebarCollapsed(false);
      this.dynamicMenuOpenClose[index] = true;
      return;
    }
    this.dynamicMenuOpenClose[index] = !this.dynamicMenuOpenClose[index];
  }

  // Handles clicks anywhere on the parent menu circle (including the padding area
  // around the icon). In the collapsed rail this expands the sidebar; otherwise it
  // preserves the original "start a new chat" behavior.
  onParentMenuClick(item: any, index: number): void {
    const isExpandable = (item?.children?.length > 0) || item?.menu_code === 'History';
    if (!this.showSidebar && isExpandable) {
      this.intService.setSidebarCollapsed(false);
      this.dynamicMenuOpenClose[index] = true;
      return;
    }
    this.newAbioChat(item.menu_code);
  }

  newAbioChat(param, parentMenuCode?: string) {
    // debugger;
    if (window.innerWidth <= 1024 && param !== 'History' && param !== 'Admin') {
      this.intService.setSidebarCollapsed(true);
    }
    this.intService.triggerRefreshHeader('');
    this.tts.resetAudio();
    this.chatType = 'Chat';
    this.chatHistoryType = 'Chat';
    if (this.isVisible) {
      const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
        width: '350px',
        data: { message: 'Are you sure you want to get out of Roleplay?' }
      });

      dialogRef.afterClosed().subscribe(result => {
        if (!result) {
          return;
        } else {
          this.rolePlayService.hideDiv(false);
          let questionRequest: RolePlayEndRequest = this.dataFromParent;
          if (questionRequest.session_type === 'role-play') {
            this.rolePlayService.endRolePlayRequest(questionRequest).subscribe((data: any) => {
              this.rolePlayService.submitFeedbackHandler({ type: 'S', value: data.roleplay_session_score, feedback: data.roleplay_session_feedback });
            });
            this.intService.stopSessionSubject.next('');
          }
          this.switchModule(param, parentMenuCode);
        }
      });
    } else {
      this.showChatFocus = true;
      this.switchModule(param, parentMenuCode);
    }
  }
  switchModule(param, parentMenuCode?: string) {
    this.selectedMenu = param;
    this.selectedParentMenu = parentMenuCode || null;
    this.selectedHistoryId = null;
    switch (param) {
      case 'emailcoach':
        this.intService.setChatStatus({ chat_identifier: 'emailcoach' });
        this.Router.navigate(['/app-abiomed-chat'], { queryParams: { chat: 'EC' }, skipLocationChange: true });
        break;
      case 'summarizer':
        this.intService.setChatStatus({ chat_identifier: 'summarizer' });
        this.Router.navigate(['/app-abiomed-chat'], { queryParams: { chat: 'SM' }, skipLocationChange: true });
        this.showChatFocus = false;
        this.chatHistoryType = 'summarizer';
        this.showRegion = false;
        this.isHistoryClicked = false;
        break;
      case 'roleplay':
        this.chatHistoryType = 'role-play';
        this.roleplayHandler();
        break;
      case QUIZ_MENU_CODE:
        this.chatHistoryType = 'quiz';
        this.quizHandler();
        break;
      case 'clinicaldataguru':
        this.intService.setChatStatus({ chat_identifier: 'clinicaldataguru' });
        this.Router.navigate(['/app-abiomed-chat'], { queryParams: { chat: 'CG' }, skipLocationChange: true });
        break;
      case 'impellaguru':
        this.intService.setChatStatus({ chat_identifier: 'impellaguru' });
        this.Router.navigate(['/app-abiomed-chat'], { queryParams: { chat: 'PG' }, skipLocationChange: true });
        break;
      case 'newchat':
        this.intService.setChatStatus({ chat_identifier: 'newchat' });
        this.Router.navigate(['/app-abiomed-chat'], { queryParams: { chat: 'NC' }, skipLocationChange: true });
        this.showChatFocus = false;
        this.showRegion = true;
        if (this.isHistoryClicked) {
          this.isHistoryClicked = false;
          this.toastr.info('New chat session has started.', '', { positionClass: 'toast-top-right' });
        }
        this.getProductMetaData();
        break;
      case 'FAQ':
        this.intService.setChatStatus({ chat_identifier: 'newchat' });
        this.Router.navigate(['/app-cust-faq'], { queryParams: { chat: 'FAQ' }, skipLocationChange: true });
        this.chatType = 'faq';
        this.subType = "";
        this.chatHistoryType = 'faq';
        break;
      case 'systemPrompt':
        this.systemPrompt();
        this.showChatFocus = false;
        this.showRegion = false;
        this.isHistoryClicked = false;
        break;
      case 'Skills':
        this.goToSkills();
        this.showChatFocus = false;
        this.showRegion = false;
        this.isHistoryClicked = false;
        break;
      case 'global_configuration':
        this.goToGlobalConfiguration();
        this.showChatFocus = false;
        this.showRegion = false;
        this.isHistoryClicked = false;
        break;
      case  'requestCategory':
        this.requestCategory();
        this.showChatFocus = false;
        this.showRegion = false;
        this.isHistoryClicked = false;
        break;
      case 'AdminDashboard':
        this.adminDashboard();
        this.showChatFocus = false;
        this.showRegion = false;
        this.isHistoryClicked = false;
        break;
      case 'Customize':
        this.Customize();
        this.showChatFocus = false;
        this.showRegion = false;
        this.isHistoryClicked = false;
        break;
      case 'query_coach':
        this.queryCoach();
        this.showChatFocus = false;
        this.showRegion = false;
        this.isHistoryClicked = false;
        break;
      case 'veevaVault':
        this.veevaVault();
        this.showChatFocus = false;
        this.showRegion = false;
        this.isHistoryClicked = false;
        break;
      case 'DataSource':
        this.vvdashboard();
        this.showChatFocus = false;
        this.showRegion = false;
        this.isHistoryClicked = false;
        break;

      case 'vvdashboard':
        this.vvdashboard();
        this.showChatFocus = false;
        this.showRegion = false;
        this.isHistoryClicked = false;
        break;
      case 'AMPDataSource':
        this.ampDataSource();
        this.showChatFocus = false;
        this.showRegion = false;
        this.isHistoryClicked = false;
        break;
      case 'responseFeedback':
        this.menuHeader = 'Response Feedback'
        this.feedbackHandler(this.menuHeader);
        this.showChatFocus = false;
        this.showRegion = false;
        this.isHistoryClicked = false;
        break;

      case 'trainerdashboard':
        this.trainerdashboard();
        this.showRegion = true;
        break;
      case 'feedbackTraineeHandler':
        this.feedbackTraineeHandler();
        this.showChatFocus = false;
        this.showRegion = false;
        this.isHistoryClicked = false;
        break;
      case 'historyHandler':
        this.historyHandler();
        break;
      case 'EmailTemplate':
        this.EmailTemplate();
        this.showRegion = false;
        this.isHistoryClicked = false;
        break;
      case 'bugReport':
        this.Router.navigate(['/app-request-list'], { skipLocationChange: true });
        break;
      case 'issueRequest':
        this.Router.navigate(['/app-request-list'], { skipLocationChange: true });
        this.showChatFocus = false;
        this.showRegion = false;
        this.isHistoryClicked = false;
        break;
      case 'roleplayFeedback':
      case 'roleplayfeedback':
        this.navigateToRoleplayFeedbackList();
        this.isHistoryClicked = false;
        break;
      default:
    }
    if (param === 'newchat') {
      param = 'Chat';
    }
    if (param === 'summarizer') {
      param = 'summarizer'; // Todo: Once compelte the history flow for summarizer we can change this to 'summarizer'
    }

    if(param === 'quiz'){
      this.getQuizHistoryList();
    } else if (param !== 'FAQ') {
      this.subType = param;
      this.getHistoryList(this.chatType, this.subType);
    }
  }

  // -----------------------------------------------------------------
  // METHOD PURPOSE:
  //   Loads the quiz chat history; `quizHistorySync` fills the History
  //   groups when it arrives (and on later refreshes).
  //
  // MODIFICATION HISTORY (latest first – keep ONLY the last 3):
  //   [JHUD-5314] 2026-10-29 21:00 | Vikas Kumar | Initial implementation.
  // -----------------------------------------------------------------
  getQuizHistoryList(): void {
    // A late chat-history response must not overwrite the quiz list.
    this.historySubscription?.unsubscribe();
    this.applyQuizHistory(this.quizNavigation.recentHistory());
    this.quizNavigation.loadRecent();
  }

  private applyQuizHistory(history: QuizHistoryResponse): void {
    this.todayHistory = history.today ?? [];
    this.yesterdayHistory = history.current_week ?? [];
    this.monthHistory = history.one_month_ago ?? [];
    this.weekHistory = history.last_week ?? [];
    this.historyList = {
      today: this.todayHistory,
      yesterday: this.yesterdayHistory,
      one_month_ago: this.monthHistory,
      last_week: this.weekHistory,
    };
  }

  confirmAndHandleDetails(chatSessionId: number, dashRolePlay?: string) {
    if (this.selectedMenu === 'summarizer') {
      this.chatHistoryType = this.selectedMenu;
    }
    this.selectedParentMenu = 'History';
    this.selectedMenu = null;
    this.selectedHistoryId = chatSessionId;
    this.details(chatSessionId, dashRolePlay);
    this.tts.resetAudio();
    this.isHistoryClicked = true;
  }
  details(chatSessionId: number, dashRolePlay?: string) {
    if (window.innerWidth <= 1024) {
      this.intService.setSidebarCollapsed(true);
    }
    switch (dashRolePlay.toLowerCase()) {
      case 'chat':
        //  this.intService.setChatStatus({ chat_identifier: 'chatDetails', chat_session_id: chatSessionId });
        this.intService.loadHistoryDetailsHandler({ chat: 'CHAT', id: chatSessionId });
        this.Router.navigate(['/app-abiomed-chat'], { queryParams: { id: chatSessionId, chat: 'CD' }, skipLocationChange: true });
        if (dashRolePlay === "") {
          setTimeout(() => {
            this.loadRegions('history');
            this.setProductValueFromHistory()
          }, 1000);
        }
        break;
      case 'summarizer':
        this.intService.loadHistoryDetailsHandler({ chat: 'SUMMARIZER', id: chatSessionId });
        this.Router.navigate(['/app-abiomed-chat'], { queryParams: { chat: 'SM' }, skipLocationChange: true });
        break;
      case 'faq':
        this.intService.loadHistoryDetailsHandler({ chat: 'FAQ', id: chatSessionId });
        break;
      case 'role-play':
        const data = { scenario_id: 28 }
        this.intService.loadHistoryDetailsHandler({ chat: 'ROLEPLAY', id: chatSessionId });
        this.rolePlayService.setRoleplayInfoSidebar(data);
        this.rolePlayService.setRoleplayClicked('rolePlayClicked');
        this.Router.navigate([`app-roleplay-history/${chatSessionId}`], { skipLocationChange: true });
        break;
      case QUIZ_MENU_CODE:
        this.intService.loadHistoryDetailsHandler({ chat: 'QUIZ', id: chatSessionId });
        this.quizNavigation.openQuiz(chatSessionId);
        break;
      default:
        this.Router.navigate(['/app-abiomed-chat'], { queryParams: { chat: 'NC' }, skipLocationChange: true });
        break;
    }
  }


  toggleOptions() {
    this.showOptions = !this.showOptions;
  }

  EmailTemplate() {
    this.Router.navigate(['/app-email-template'], { skipLocationChange: true });
  }

  toggleEdit(item: any): void {
    item.isEditing = true; // Set the editing mode to true
    item.newChatName = item.chat_name; // Initialize the newChatName with the current chat_name
  }

  onInputChange(event: KeyboardEvent | FocusEvent, item: any) {
    this.tts.resetAudio();
    if (event.type === 'keyup' && (event as KeyboardEvent).key !== 'Enter') {
      return;
    }
    if (!this.isRenaming) {
      this.isRenaming = true;
      if (event.type === 'keyup' && (event as KeyboardEvent).key === 'Enter') {
        item.lastKey = 'Enter'
        this.rename(item);
      } else if (event.type === 'blur' && item?.lastKey === 'Enter') {
        item.lastKey = ''
      } else if (event.type === 'blur' && item?.lastKey !== 'Enter') {
        this.rename(item);
      }
      setTimeout(() => this.isRenaming = false, 100);
    }
  }

  rename(item: any): void {
    const chatHistoryId = item.chat_session_id;
    const newName = item.newChatName;
    if (newName === '') {
      this.toastr.error('Please enter some text.', '', { positionClass: 'toast-top-right' });
      return;
    }
    this.http.patch<any>(`${CONVERSATION_SERVICE.updateChatSession}/${chatHistoryId}`, { chat_name: newName }).subscribe(
      () => {
        this.menu.closeMenu();
        this.toastr.success('History has been updated Successfully.', '', { positionClass: 'toast-top-right' });
        item.chat_name = newName;
        item.isEditing = false; // Exit editing mode
      },
    );
  }

  delete(chatHistoryId: number): void {
    this.intService.chatSessionObservable$.subscribe(value => {
      this.chatSession_Id = parseInt(value);
    });

    if (this.chatSession_Id == chatHistoryId) {
      this.toastr.error('You can not delete the current Scenario.', '', { positionClass: 'toast-top-right' });
    } else {
      const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
        width: '350px',
        data: { message: 'Are you sure, you want to delete?' }
      });

      dialogRef.afterClosed().subscribe(result => {
        if (result) {
          this.http.delete<any>(`${CONVERSATION_SERVICE.deleteChatSession}/${chatHistoryId}`).subscribe(
            () => {
              this.toastr.success('History has been deleted Successfully.', '', { positionClass: 'toast-top-right' });
              this.getHistoryList(this.chatType, this.subType, '', '', 'delete');
            }
          );
        }
      });
    }
  }

  changeCategory(e) {
    this.PlatformRegionService.setSelectedPlatformProductByProductCode(e.value);
    const selectedProductPlatform = this.PlatformRegionService.selectedProductPlatform;
    this.menuForm.controls['categoryName'].setValue(sessionStorage.getItem('businessUnitCode'));
    const buttonElement = document.activeElement as HTMLElement;
    buttonElement.blur();
    this.toastr.success(`Switched to ${selectedProductPlatform.business_unit} Platform Group.`, '', { positionClass: 'toast-top-right' });
    setTimeout(() => {
      this.tts.resetAudio();
      if (window.innerWidth <= 1024) {
        this.intService.setSidebarCollapsed(true);
      }

      sessionStorage.setItem('businessUnitCode', selectedProductPlatform.business_unit_code); // Product Code
      sessionStorage.setItem('businessUnit', selectedProductPlatform.business_unit); // Product Name
      this.menuForm.controls['categoryName'].setValue(e.value);
      this.Router.navigate(['/app-abiomed-chat'], { queryParams: { chat: 'NC' }, skipLocationChange: true });
      this.getProductMetaData();
      setTimeout(() => {
        this.intService.isProductSelected.next('platform');
      }, 0);
      this.showChatFocus = false;
      this.selectedMenu = 'newchat';
      this.intService.triggerRefreshHeader('platformchange');
    }, 1000); // Adjust the timeout duration as needed
  }

  logout() {
    if (confirm("Do you want to logout ") == true) {
      this.Router.navigate(['/app-home'], { skipLocationChange: true });
    }
  }

  loadRegions(selectedRegion, isFirstTime?: boolean) {
    this.showLoader('region-loader');
    this.ChatService.getPrimaryRegion(sessionStorage.getItem('businessUnitCode')).subscribe(val => {
      this.regionData = val;
      this.regionSelectedValues = '';
      this.regionFilteredOptions = this.menuForm.controls['regionSearchTextboxControl'].valueChanges
        .pipe(
          startWith<string>(''),
          map((name: any) => this._filterRegion(name))
        );
      this.hideLoader('region-loader');
      if (selectedRegion === 'region') {

      } else if (selectedRegion === 'market') {

      } else if (selectedRegion === 'profile') {
        this.menuForm.controls['regionSelectFormControl'].setValue(sessionStorage.getItem('defaultRegion'));
        this.regionSelectedValues = sessionStorage.getItem('defaultRegion');
      } else if (selectedRegion === 'history') {
        this.menuForm.controls['regionSelectFormControl'].setValue(sessionStorage.getItem('region'));
        this.regionSelectedValues = sessionStorage.getItem('region');
      } else {
        if (isFirstTime && sessionStorage.getItem('defaultProduct').toString() === sessionStorage.getItem('businessUnitCode').toString()) {
          this.menuForm.controls['regionSelectFormControl'].setValue(sessionStorage.getItem('defaultRegion'));
          this.regionSelectedValues = sessionStorage.getItem('defaultRegion');
        }
      }
    });
  }




  private parseStoredArray(key: string): string[] {
    const raw = sessionStorage.getItem(key);
    if (!raw || raw === 'null' || raw === 'undefined') return [];
    try {
      const parsed = JSON.parse(raw);
      if (Array.isArray(parsed)) return parsed.map(String).map(s => s.trim()).filter(Boolean);
    } catch { /** not JSON, fall back to CSV */ }
    return String(raw).split(',').map(s => s.trim()).filter(Boolean);
  }


  private _filterRegion(name: string): any[] {
    const filterValue = name.toLowerCase();
    // Set selected values to retain the selected checkbox state 
    this.regionSetSelectedValues();
    this.menuForm.controls['regionSelectFormControl'].patchValue(this.regionSelectedValues);
    if (this.regionSelectedValues && this.regionSelectedValues.toString() !== 'undefined') {
      sessionStorage.setItem('region', this.regionSelectedValues.toString());
    } else {
      sessionStorage.setItem('region', null);
    }
    if (!this.regionSelectedValues) {
      this.marketSelectedValues = [];
      this.menuForm.controls['marketSelectFormControl'].patchValue([]);
    }
    let filteredList = [];
    if (this.regionData && this.regionData.length) {
      filteredList = this.regionData.filter(option => option.region_name.toLowerCase().indexOf(filterValue) === 0);
    } else {
      filteredList = [];
    }
    return filteredList;
  }

  regionSelectionChange(event, option: string) {
    if (event.isUserInput) {
      if (event.source.selected) {
        this.regionSelectedValues = option;
      }
    }
  }

  regionOpenedChange(e) {
    this.menuForm.controls['regionSearchTextboxControl'].patchValue('');
    if (e == true) {
      this.regionSearchTextBox.nativeElement.focus();
      this.previousRegionValue = sessionStorage.getItem("region");
    } else {
      if (this.menuForm.controls['regionSelectFormControl'].value === "undefined" || this.menuForm.controls['regionSelectFormControl'].value === "") {
        this.menuForm.controls['regionSelectFormControl'].setValue("null")
      }
      if (this.isHistoryClicked) {
        if (this.menuForm.controls['regionSelectFormControl'].value && this.menuForm.controls['regionSelectFormControl'].value !== "undefined" && this.previousRegionValue.length > 1 && this.menuForm.controls['regionSelectFormControl'].value[0] !== this.previousRegionValue[0]) {
          this.refreshChat('region');
        }
      } else if (
        this.previousRegionValue !== this.menuForm.controls['regionSelectFormControl'].value) {
        this.refreshChat('region');
        if (this.menuForm.controls['regionSelectFormControl'].value && this.menuForm.controls['regionSelectFormControl'].value !== "undefined") {
        } else {
          this.marketData = [];
          this.marketSelectedValues = [];
          this.menuForm.controls['marketSelectFormControl'].setValue([]);
          sessionStorage.setItem('market', 'null');
        }
      }
      this.isHistoryClicked = false;
    }
  }

  regionClearSearch(event) {
    event.stopPropagation();
    this.menuForm.controls['regionSearchTextboxControl'].patchValue('');
  }

  regionSetSelectedValues() {
    if (this.menuForm.controls['regionSelectFormControl'].value && this.menuForm.controls['regionSelectFormControl'].value !== "null" && this.menuForm.controls['regionSelectFormControl'].value.length > 0) {
      this.regionSelectedValues = this.menuForm.controls['regionSelectFormControl'].value;

    }

  }


  private _filterMarket(name: string): String[] {
    const filterValue = name.toLowerCase();
    // Set selected values to retain the selected checkbox state 
    this.marketSetSelectedValues();
    let filteredList = this.marketData.filter(option => option.primary_market.name.toLowerCase().indexOf(filterValue) === 0);
    let availableList = [];
    this.marketSelectedValues.forEach(market => {
      filteredList.forEach(obj => {
        if (obj.primary_market.code === market) {
          availableList.push(market)
        }
      });
    });
    if (this.marketSelectedValues.length && this.marketSelectedValues[0] !== 'null') {
      sessionStorage.setItem('market', this.marketSelectedValues.toString())
    } else if (sessionStorage.getItem('market') == "null" || sessionStorage.getItem('market') === undefined ||
      sessionStorage.getItem('market') === null || sessionStorage.getItem('market') === "undefined" || sessionStorage.getItem('market') === "") {
      sessionStorage.setItem('market', null)
    }

    this.menuForm.controls['marketSelectFormControl'].setValue(this.marketSelectedValues);

    return filteredList;
  }

  marketSelectionChange(event) {
    if (event.isUserInput && event.source.selected == false) {
      let index = this.marketSelectedValues.indexOf(event.source.value);
      this.marketSelectedValues.splice(index, 1)
    }
  }

  marketOpenedChange(e) {
    this.menuForm.controls['marketSearchTextboxControl'].patchValue('');
    if (this.menuForm.controls['regionSelectFormControl']?.value === "null" ||
      this.menuForm.controls['regionSelectFormControl']?.value === "" ||
      this.menuForm.controls['regionSelectFormControl']?.value === undefined
    ) {
      this.marketData = [];
      this.marketSelectedValues = [];
    }
    if (e == true) {
      this.marketSearchTextBox.nativeElement.focus();
      if (sessionStorage.getItem("market") === "null" || sessionStorage.getItem("market") === undefined) {
        this.previousMarketValue = [];
      } else {
        this.previousMarketValue = sessionStorage.getItem("market").split(",")
      }

    } else {
      if (this.isHistoryClicked) {
        if (JSON.stringify(this.previousMarketValue) !== JSON.stringify(this.menuForm.controls['marketSelectFormControl']?.value) && this.previousMarketValue.length > 1 && this.menuForm.controls['marketSelectFormControl']?.value[0] !== 'null') {
          this.refreshChat('market');
        } else if (JSON.stringify(this.previousMarketValue) !== JSON.stringify(this.menuForm.controls['marketSelectFormControl']?.value)) {
          this.refreshChat('market');
        }
      } else if (JSON.stringify(this.previousMarketValue) !== JSON.stringify(this.menuForm.controls['marketSelectFormControl']?.value)) {
        this.refreshChat('market');
      }
    }
  }

  marketClearSearch(event) {
    event.stopPropagation();
    this.menuForm.controls['marketSearchTextboxControl'].patchValue('');
  }

  marketSetSelectedValues() {
    if (this.menuForm.controls['marketSelectFormControl'].value && this.menuForm.controls['marketSelectFormControl'].value.length > 0) {
      this.menuForm.controls['marketSelectFormControl'].value.forEach((e) => {
        if (this.marketSelectedValues.indexOf(e) == -1) {
          this.marketData.forEach(obj => {
            if (obj.primary_market.code === e) {
              this.marketSelectedValues.push(e);
            }
          });
        }
      });
    }
  }

  showLoader(loaderName) {
    const loader = document.getElementById(loaderName);
    if (loader) {
      loader.style.display = 'inline-block';
    }
  }

  hideLoader(loaderName) {
    const loader = document.getElementById(loaderName);
    if (loader) {
      loader.style.display = 'none';
    }
  }


  refreshChat(refreshfrom) {
    if ((sessionStorage.getItem('defaultRegion') === "null") && (sessionStorage.getItem('region') === "null")) {
      return;
    }
    setTimeout(() => {
      this.tts.resetAudio();
      this.Router.navigate(['/app-abiomed-chat'], { queryParams: { chat: 'NC' }, skipLocationChange: true });
      this.toastr.info('New chat session has started.', '', { positionClass: 'toast-top-right' });
      setTimeout(() => {
        this.intService.isProductSelected.next(refreshfrom);
      }, 0);
      this.showChatFocus = false;
      this.selectedMenu = 'newchat';
      this.intService.triggerRefreshHeader('');
    }, 1000);
  }

  getMarketNameByCode(code) {
    let filteredVal: any;
    if (typeof (code) == 'object') {
      let codes = [];
      code.forEach(cd => {
        this.marketData.forEach((market: any) => {
          if (market.primary_market.code.toString() === cd.toString()) {
            codes.push(market.primary_market.name);
          }
        });
      });
      filteredVal = codes
    } else if (typeof (code) == 'string') {
      let filteredName: any = this.marketData.find((market: any) => market.primary_market.code.toString() === code.toString());
      filteredVal = filteredName?.primary_market.name
    }
    return filteredVal
  }


  setProductValueFromHistory() {
    this.productSelectedValues = sessionStorage.getItem('product').split('~');
    this.menuForm.controls['productSelectFormControl'].setValue(this.productSelectedValues);
  }

  getProductMetaData() {
    this.ChatService.getProductMetaData(sessionStorage.getItem('businessUnitCode')).subscribe(val => {
      this.productData = [];
      this.productSelectedValues = [];
      let allCodes = [];
      val.forEach(element => {
        if (element.code !== "All") {
          this.productData.push(element);
          allCodes.push(element.code);
        }
      });
      this.productSelectedValues = allCodes;
      if (this.productSelectedValues.length) {
        var permittedValues = this.productSelectedValues.map(value => value).join("~");
        // console.log('Product selected values',permittedValues)
        sessionStorage.setItem('product', permittedValues);
      } else {
        sessionStorage.setItem('product', null);
      }
      this.menuForm.controls['productSelectFormControl'].setValue(this.productSelectedValues);
      this.productFilteredOptions = this.menuForm.controls['productSearchTextboxControl']?.valueChanges
        .pipe(
          startWith<string>(''),
          map((name: any) => this._filterProduct(name))
        );
    })
  }

  productOpenedChange(e) {
    this.menuForm.controls['productSearchTextboxControl']?.patchValue('');
    if (e == true) {
      this.productSearchTextBox?.nativeElement.focus();
      this.previousProductValue = sessionStorage.getItem("product");
    } else {
      const arrayValues = this.menuForm.controls['productSelectFormControl'].value;
      const joinedString = arrayValues.join('~ ');
      if (
        this.menuForm.controls['productSelectFormControl'].value.length) {
        if (this.previousProductValue !== this.menuForm.controls['productSelectFormControl'].value.toString()
          && sessionStorage.getItem("sessionId") !== "0") {
          this.refreshChat('product');
        }
      } else {
        let allCodes = [];
        this.productData.forEach(element => {
          if (element.code !== "All") {
            allCodes.push(element.code);
          }
        });
        this.productSelectedValues = allCodes;
        this.menuForm.controls['productSelectFormControl'].setValue(allCodes)
        sessionStorage.setItem("product", joinedString)
        this.toastr.info(SPECIALITY_INFO_MSG, '', { positionClass: 'toast-top-right' });

      }
      sessionStorage.setItem("product", joinedString);
    }
  }

  productClearSearch(event) {
    event.stopPropagation();
    this.menuForm.controls['productSearchTextboxControl']?.patchValue('');
  }

  addAll(isChecked: string) {
    if (isChecked === 'true') {
      let allCodes = [];
      this.productData.forEach(element => {
        allCodes.push(element.code);
      });
      this.productSelectedValues = allCodes;
      this.menuForm.controls['productSelectFormControl'].setValue(this.productSelectedValues);
    } else {
      this.productSelectedValues = [];
      this.menuForm.controls['productSelectFormControl'].setValue(this.productSelectedValues);
    }
  }

  productSelectionChange(event) {
    if (event.isUserInput && event.source.selected == false) {
      let index = this.productSelectedValues.indexOf(event.source.value);
      this.productSelectedValues.splice(index, 1);
    }
  }

  private _filterProduct(name: string): String[] {
    const filterValue = name.toLowerCase();
    // Set selected values to retain the selected checkbox state 
    this.productSetSelectedValues();
    let filteredList = this.productData.filter(option => option.label.toLowerCase().indexOf(filterValue) === 0);
    let availableList = [];
    this.productSelectedValues.forEach(prod => {
      filteredList.forEach(obj => {
        if (obj.code === prod) {
          availableList.push(prod)
        }
      });
    });
    this.menuForm.controls['productSelectFormControl'].setValue(this.productSelectedValues);

    return filteredList;
  }

  productSetSelectedValues() {
    if (this.menuForm.controls['productSelectFormControl'].value && this.menuForm.controls['productSelectFormControl'].value.length > 0) {
      this.menuForm.controls['productSelectFormControl'].value.forEach((e) => {
        if (this.productSelectedValues.indexOf(e) == -1) {
          this.productData.forEach(obj => {
            if (obj.code === e) {
              this.productSelectedValues.push(e);
            }
          });
        }
      });
    }
  }

  getProductNameByCode(code) {
    let filteredVal: any;
    if (typeof (code) == 'object') {
      let codes = [];
      code.forEach(cd => {
        this.productData.forEach((prod: any) => {
          if (prod.code.toString() === cd.toString()) {
            codes.push(prod.label);
          }
        });
      });
      filteredVal = codes
    } else if (typeof (code) == 'string') {
      let filteredName: any = this.productData.find((prod: any) => prod.code.toString() === code.toString());
      filteredVal = filteredName?.label
    }
    return filteredVal
  }

}